export var colors = {
    admin: '#42a5f5',
    producer: '#1B6688',
    roaster: '#CBC741',
    warehouse: '#ffffff',
    // TYPICA colors
    green: '#0f7e58',
    blue: '#1b8888',
    yellow: '#cbc741',
    red: '#e34837',
    gray: '#d8d8d8',
    beige: '#d1c4aa',
    black: '#1e181c',
    purple: '#7a318d',
};
